/* Core & libraries */
import React, { useEffect } from 'react';
import { useTheme } from 'react-jss';
import { FormattedMessage } from 'react-intl';

/* Helpers, constants, custom methods, internal libraries */
import { useAnalytics } from "../../hooks/useAnalytics";
import { useUserContext } from "../../contexts/userContext";
import { AIRLINES, PAGE_TITLES} from "../../constants/appConstants";
import { NOT_FOUND_ROUTE } from "../../constants/routes";

/* Components */
import { ReactComponent as AALogo } from '../../resources/images/aa-logo.svg';
import EscalationHeader from "../../components/escalationPageHeader";
import {ReactComponent as CHOICELogo} from '../../resources/images/choice-business-direct-logo.svg';

/* Styles */
import styles from './styles.js';
import generalStyles from '../../resources/styles/general';

const EscalationMessageSent = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const general = generalStyles({ theme });
  const { initAnalytics } = useAnalytics();
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  const providerConfig = {
    [AIRLINES.AA]: {
      logo: <AALogo />,
      title: 'escalation.message.title.AA',
      description: 'escalation.message.description.AA',
    },
    [AIRLINES.CHOICE]: {
      logo: <CHOICELogo />,
      title: 'escalation.message.title.CHOICE',
      description: 'escalation.message.description.CHOICE',
    },
  };

  const config = providerConfig[providerCode] ?? providerConfig[AIRLINES.AA];

  useEffect(() => {
    if (providerCode && ![AIRLINES.AA, AIRLINES.CHOICE].includes(providerCode)) {
      window.location.href = NOT_FOUND_ROUTE;
    }
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["escalationFormConfirmation"]
    };
    initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  return (
    (providerCode && [AIRLINES.AA, AIRLINES.CHOICE].includes(providerCode)) &&
    <div className={`${general.main} ${classes.escalation}`}>
      <EscalationHeader hideSignOut={providerCode === AIRLINES.CHOICE}/>
      {config.logo}
      <div className={classes.leaveContainer}>
        <h1 className={classes.title}>
          <FormattedMessage id={config.title} />
        </h1>
        <p className={classes.description}>
          <FormattedMessage id={config.description} />
        </p>
      </div>
    </div>
  );
};

export default EscalationMessageSent;
